import { updateProjectDraft } from '@common/api/graphql/updateProjectDraftGql';
import {
  updateProjectDraftFailure,
  updateProjectDraftStart,
  updateProjectDraftSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';

const updateProjectDraftSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    const syncedDate = new Date();
    dispatch(updateProjectDraftSuccess(syncedDate));
    return Promise.resolve();
  };

export const updateProjectDraftThunk =
  (): AppThunkAction<Promise<void>> => (dispatch, getState) => {
    dispatch(updateProjectDraftStart());
    const projectDraft = {
      ...getState().selectedProjectDraft,
      projectJson: JSON.stringify(getState().selectedProjectDraft.projectJson)
    };

    return updateProjectDraft(projectDraft)
      .then(() => dispatch(updateProjectDraftSuccessThunk()))
      .catch(error => {
        dispatch(updateProjectDraftFailure());
        return Promise.reject(JSON.stringify(error));
      });
  };
